import { heading, text, button, image, divider, spacer, social, footerBlk, headerBar, columns, hero } from './builders'

const FOOTER = footerBlk(
  'You are receiving this email because you have an account with NovaPay. &copy; 2026 NovaPay Financial, Inc. &middot; 500 Market Street, San Francisco, CA 94105<br/>' +
    '<a href="{{unsubscribe_url}}" style="color:#6b7280;text-decoration:underline;">Unsubscribe</a> &nbsp;&middot;&nbsp; ' +
    '<a href="{{preferences_url}}" style="color:#6b7280;text-decoration:underline;">Manage preferences</a> &nbsp;&middot;&nbsp; ' +
    '<a href="{{privacy_url}}" style="color:#6b7280;text-decoration:underline;">Privacy Policy</a>',
  { backgroundColor: '#eef2ff', color: '#6b7280', fontSize: '12' }
)

const TEMPLATES = [
  {
    id: 'fintech-verify-account-kyc',
    category: 'fintech',
    name: 'Verify Your Account (KYC)',
    description: 'Prompt the customer to complete identity verification to unlock full account access.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Dashboard', 'Support', 'Security'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#4f46e5',
        paddingTop: 20,
        paddingBottom: 20
      }),
      hero('Identity Verification', '4f46e5', 'ffffff', { alignment: 'center' }),
      spacer(12),
      heading('Let&rsquo;s verify your identity', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '8',
        paddingBottom: '8'
      }),
      text(
        'Hi $first_name,<br/><br/>Your NovaPay account is almost ready. To keep your money safe and comply with financial regulations, we need to confirm a few details before you can send, receive, or withdraw funds.',
        { color: '#374151', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(8),
      text(
        '<strong>What you&rsquo;ll need:</strong><br/>&bull; A government-issued photo ID (passport or driver&rsquo;s license)<br/>&bull; A clear selfie for liveness matching<br/>&bull; About 2 minutes of your time',
        {
          color: '#374151',
          fontSize: '14',
          alignment: 'left',
          lineHeight: '1.7',
          backgroundColor: '#eef2ff',
          paddingLeft: '48',
          paddingRight: '48',
          paddingTop: '18',
          paddingBottom: '18'
        }
      ),
      spacer(16),
      button('Verify now', '{{kyc_verification_url}}', {
        backgroundColor: '#4f46e5',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '40',
        buttonPaddingV: '14'
      }),
      spacer(12),
      text(
        'Your documents are encrypted in transit and at rest, and are used only to confirm your identity. NovaPay will never ask for your password or full card number by email.',
        { color: '#6b7280', fontSize: '12', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(16),
      divider(),
      social(),
      FOOTER
    ]
  },
  {
    id: 'fintech-transaction-receipt',
    category: 'fintech',
    name: 'Transaction Receipt',
    description: 'Confirm a completed transfer with the amount, transaction ID, and updated wallet balance.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Activity', 'Wallet', 'Help'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#4f46e5',
        paddingTop: 20,
        paddingBottom: 20
      }),
      hero('Payment Confirmed', '0ea5e9', 'ffffff', { alignment: 'center' }),
      spacer(12),
      heading('Payment sent', {
        fontSize: '24',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '8',
        paddingBottom: '4'
      }),
      text('Hi $first_name, your transfer went through successfully. Here&rsquo;s your receipt.', {
        color: '#374151',
        fontSize: '15',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32'
      }),
      spacer(12),
      heading('$amount', {
        fontSize: '34',
        fontWeight: '800',
        alignment: 'center',
        color: '#4f46e5',
        backgroundColor: '#f5f3ff',
        paddingTop: '20',
        paddingBottom: '20'
      }),
      spacer(8),
      columns(
        [
          text('<strong>Transaction ID</strong><br/>Date<br/><strong>New balance</strong>', {
            color: '#6b7280',
            fontSize: '14',
            alignment: 'left',
            lineHeight: '2.0',
            paddingLeft: '24'
          }),
          text('$transaction_id<br/>{{transaction_date}}<br/>$wallet_balance', {
            color: '#111827',
            fontSize: '14',
            alignment: 'right',
            lineHeight: '2.0',
            paddingRight: '24'
          })
        ],
        { backgroundColor: '#f9fafb' }
      ),
      spacer(16),
      button('View transaction', '{{transaction_details_url}}', {
        backgroundColor: '#4f46e5',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '36',
        buttonPaddingV: '13'
      }),
      spacer(12),
      text(
        'If you don&rsquo;t recognize this transaction, <a href="{{dispute_url}}" style="color:#4f46e5;">report it immediately</a> so we can secure your account.',
        { color: '#6b7280', fontSize: '12', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(16),
      divider(),
      social(),
      FOOTER
    ]
  },
  {
    id: 'fintech-cashback-rewards-summary',
    category: 'fintech',
    name: 'Cashback / Rewards Summary',
    description: 'Monthly recap of cashback earned with a call to view and redeem rewards.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Rewards', 'Wallet', 'Offers'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#7c3aed',
        paddingTop: 20,
        paddingBottom: 20
      }),
      hero('Your Cashback Rewards', '7c3aed', 'ffffff', { alignment: 'center' }),
      spacer(12),
      heading('You earned cashback this month', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '8',
        paddingBottom: '4'
      }),
      text('Nice work, $first_name &mdash; your everyday spending paid you back.', {
        color: '#374151',
        fontSize: '15',
        alignment: 'center',
        lineHeight: '1.6'
      }),
      spacer(12),
      heading('$cashback_amount', {
        fontSize: '40',
        fontWeight: '800',
        alignment: 'center',
        color: '#ffffff',
        backgroundColor: '#7c3aed',
        paddingTop: '28',
        paddingBottom: '8'
      }),
      text('earned in cashback this month', {
        color: '#ede9fe',
        fontSize: '13',
        alignment: 'center',
        backgroundColor: '#7c3aed',
        paddingBottom: '24'
      }),
      spacer(16),
      columns(
        [
          text('<strong>Groceries</strong><br/>3% back', {
            color: '#111827',
            fontSize: '14',
            alignment: 'center',
            lineHeight: '1.8'
          }),
          text('<strong>Dining</strong><br/>5% back', {
            color: '#111827',
            fontSize: '14',
            alignment: 'center',
            lineHeight: '1.8'
          })
        ],
        { backgroundColor: '#faf5ff' }
      ),
      spacer(16),
      button('View rewards', '{{rewards_dashboard_url}}', {
        backgroundColor: '#7c3aed',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '40',
        buttonPaddingV: '14'
      }),
      spacer(12),
      text(
        'Cashback is credited to your NovaPay wallet and never expires. Keep paying with your NovaPay card to earn more.',
        { color: '#6b7280', fontSize: '12', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(16),
      divider(),
      social(),
      FOOTER
    ]
  },
  {
    id: 'fintech-feature-launch',
    category: 'fintech',
    name: 'Feature Launch',
    description: 'Announce a new product feature with a bold hero and a try-it-now call to action.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['What&rsquo;s new', 'Wallet', 'Help'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#4f46e5',
        paddingTop: 20,
        paddingBottom: 20
      }),
      hero('Introducing Instant Vaults', '4f46e5', 'ffffff', { alignment: 'center' }),
      spacer(16),
      heading('Save automatically, spend smarter', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '4',
        paddingBottom: '8'
      }),
      text(
        'Hi $first_name,<br/><br/>Meet <strong>Instant Vaults</strong> &mdash; the easiest way to set money aside without thinking about it. Pick a goal, and NovaPay automatically rounds up your purchases and moves the spare change into a separate, high-yield vault.',
        { color: '#374151', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(8),
      text(
        '&bull; Automatic round-up saving on every purchase<br/>&bull; Up to 4.2% annual yield on your balance<br/>&bull; Withdraw instantly &mdash; no lock-in, no fees',
        { color: '#374151', fontSize: '14', alignment: 'left', lineHeight: '1.8', paddingLeft: '56', paddingRight: '56' }
      ),
      spacer(16),
      button('Try it now', '{{feature_launch_url}}', {
        backgroundColor: '#4f46e5',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '44',
        buttonPaddingV: '15'
      }),
      spacer(12),
      text('Rolling out to all NovaPay members this week. No upgrade required.', {
        color: '#6b7280',
        fontSize: '12',
        alignment: 'center',
        lineHeight: '1.6'
      }),
      spacer(16),
      divider(),
      social(),
      FOOTER
    ]
  },
  {
    id: 'fintech-security-2fa-notice',
    category: 'fintech',
    name: 'Security / 2FA Notice',
    description: 'Calm security alert about a new sign-in, with a prompt to review activity and enable 2FA.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Security', 'Account', 'Support'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#4f46e5',
        paddingTop: 20,
        paddingBottom: 20
      }),
      hero('Security Notice', '4f46e5', 'ffffff', { alignment: 'center' }),
      spacer(12),
      heading('New sign-in to your account', {
        fontSize: '24',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '8',
        paddingBottom: '4'
      }),
      text(
        'Hi $first_name,<br/><br/>We noticed a new sign-in to your NovaPay account. If this was you, no action is needed. If it wasn&rsquo;t, please secure your account right away.',
        { color: '#374151', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(12),
      text(
        '<strong>Device:</strong> {{device_name}}<br/><strong>Location:</strong> {{sign_in_location}}<br/><strong>Time:</strong> {{sign_in_time}}',
        {
          color: '#374151',
          fontSize: '14',
          alignment: 'left',
          lineHeight: '1.9',
          backgroundColor: '#f9fafb',
          paddingLeft: '40',
          paddingRight: '40',
          paddingTop: '16',
          paddingBottom: '16'
        }
      ),
      spacer(16),
      button('Review activity', '{{security_activity_url}}', {
        backgroundColor: '#4f46e5',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '40',
        buttonPaddingV: '14'
      }),
      spacer(16),
      text(
        '<strong>Add an extra layer of protection.</strong> Turn on two-factor authentication and we&rsquo;ll send a one-time verification code (a 6-digit $otp_code) whenever someone signs in, so only you can reach your money.',
        { color: '#374151', fontSize: '14', alignment: 'center', lineHeight: '1.6', paddingLeft: '36', paddingRight: '36' }
      ),
      spacer(10),
      button('Enable 2FA', '{{enable_2fa_url}}', {
        backgroundColor: '#ffffff',
        textColor: '#4f46e5',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '36',
        buttonPaddingV: '12'
      }),
      spacer(12),
      text('NovaPay will never ask you to share your $otp_code with anyone, including our support team.', {
        color: '#6b7280',
        fontSize: '12',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '40',
        paddingRight: '40'
      }),
      spacer(16),
      divider(),
      social(),
      FOOTER
    ]
  },
  {
    id: 'fintech-portfolio-update',
    category: 'fintech',
    name: 'Portfolio Update',
    description: 'Monthly investment summary showing portfolio movement with a link to full details.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Invest', 'Portfolio', 'Insights'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#4f46e5',
        paddingTop: 20,
        paddingBottom: 20
      }),
      hero('Your Monthly Portfolio Summary', '312e81', 'ffffff', { alignment: 'center' }),
      spacer(16),
      heading('Your portfolio is up this month', {
        fontSize: '25',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '4',
        paddingBottom: '4'
      }),
      text('Here&rsquo;s how your investments performed, $first_name.', {
        color: '#374151',
        fontSize: '15',
        alignment: 'center',
        lineHeight: '1.6'
      }),
      spacer(12),
      columns(
        [
          text('<strong>Total value</strong><br/><span style="font-size:22px;color:#111827;">$wallet_balance</span>', {
            color: '#6b7280',
            fontSize: '13',
            alignment: 'center',
            lineHeight: '1.8',
            backgroundColor: '#f5f3ff',
            paddingTop: '20',
            paddingBottom: '20'
          }),
          text('<strong>This month</strong><br/><span style="font-size:22px;color:#16a34a;">+4.8%</span>', {
            color: '#6b7280',
            fontSize: '13',
            alignment: 'center',
            lineHeight: '1.8',
            backgroundColor: '#f0fdf4',
            paddingTop: '20',
            paddingBottom: '20'
          })
        ],
        {}
      ),
      spacer(16),
      text(
        '<strong>Top movers</strong><br/>&bull; Global Index Fund &mdash; +6.1%<br/>&bull; Tech Growth ETF &mdash; +5.4%<br/>&bull; Bond Ladder &mdash; +1.2%',
        { color: '#374151', fontSize: '14', alignment: 'left', lineHeight: '1.8', paddingLeft: '48', paddingRight: '48' }
      ),
      spacer(16),
      button('View portfolio', '{{portfolio_dashboard_url}}', {
        backgroundColor: '#4f46e5',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '42',
        buttonPaddingV: '14'
      }),
      spacer(12),
      text(
        'Past performance is not a guarantee of future results. Investments are not FDIC insured and may lose value.',
        { color: '#6b7280', fontSize: '11', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(16),
      divider(),
      social(),
      FOOTER
    ]
  }
]

export default TEMPLATES
